<div
  class="content ui basic segment"
  style="padding: 0px"
  [ngClass]="{'loading':pending}"
>
  <div class="cac" *ngIf="type==='COMPANY_NAME' &&companies !=='no record'">
    <h2
      style="
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        color: #3f4395;
      "
    >
      Records From CAC
    </h2>
    <div class="ui divider"></div>
    <div class="item" style="margin-bottom: 30px">
      <h4
        style="
          font-weight: 700;
          font-size: 11px;
          line-height: 131.69%;
          color: #505050;
        "
      >
        COMPANY NAME
      </h4>
      <p
        style="
          font-weight: 400;
          font-size: 14px;
          line-height: 19px;
          color: #505050;
        "
      >
        {{companies?.approvedName}}
      </p>
    </div>
  </div>
  <div class="cac" *ngIf="type==='RC_NUMBER' &&  companies !=='no record'">
    <h2
      style="
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        color: #3f4395;
      "
    >
      Records From CAC
    </h2>
    <div class="ui divider"></div>
    <div class="item" style="margin-bottom: 30px">
      <h4
        style="
          font-weight: 700;
          font-size: 11px;
          line-height: 131.69%;
          color: #505050;
        "
      >
        COMPANY TYPE
      </h4>
      <p
        style="
          font-weight: 400;
          font-size: 14px;
          line-height: 19px;
          color: #505050;
        "
      >
        {{org?.contractor.actualCompanyType.optionName}}
      </p>
    </div>
    <div class="item" style="margin-bottom: 30px">
      <h4
        style="
          font-weight: 700;
          font-size: 11px;
          line-height: 131.69%;
          color: #505050;
        "
      >
        DATE OF REGISTRATION
      </h4>
      <p
        style="
          font-weight: 400;
          font-size: 14px;
          line-height: 19px;
          color: #505050;
        "
      >
        {{companies?.registrationDate | date:'d, MMMM y'}}
      </p>
    </div>
    <div class="item" style="margin-bottom: 30px">
      <h4
        style="
          font-weight: 700;
          font-size: 11px;
          line-height: 131.69%;
          color: #505050;
        "
      >
        OWNERSHIP TYPE
      </h4>
      <p
        style="
          font-weight: 400;
          font-size: 14px;
          line-height: 19px;
          color: #505050;
        "
      >
        {{org?.contractor.ownershipType.optionName}}
      </p>
    </div>
    <div class="item" style="margin-bottom: 30px">
      <h4
        style="
          font-weight: 700;
          font-size: 11px;
          line-height: 131.69%;
          color: #505050;
        "
      >
        RC NUMBER
      </h4>
      <p
        style="
          font-weight: 400;
          font-size: 14px;
          line-height: 19px;
          color: #505050;
        "
      >
        {{companies?.rcNumber}}
      </p>
    </div>
  </div>
  <div class="cac" *ngIf="type==='TIN'">
    <h2
      style="
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        color: #3f4395;
      "
    >
      Records From FIRS
    </h2>
    <div class="ui divider"></div>
    <div class="item" style="margin-bottom: 30px">
      <h4
        style="
          font-weight: 700;
          font-size: 11px;
          line-height: 131.69%;
          color: #505050;
        "
      >
        COMPANY TIN NUMBER
      </h4>
      <p
        style="
          font-weight: 400;
          font-size: 14px;
          line-height: 19px;
          color: #505050;
        "
      >
        {{tinNumber}}
      </p>
    </div>
  </div>
</div>

<div
  style="margin-top: 20px"
  *ngIf="companies ==='no record' && type==='RC_NUMBER'"
>
  <h2
    style="font-weight: 600; font-size: 16px; line-height: 19px; color: #3f4395"
  >
    Records From CAC
  </h2>
  <div class="ui divider"></div>
  <p>NO RECORD FROM CAC</p>
</div>

<div
  style="margin-top: 20px"
  *ngIf="companies ==='no record' && type==='COMPANY_NAME'"
>
  <h2
    style="font-weight: 600; font-size: 16px; line-height: 19px; color: #3f4395"
  >
    Records From CAC
  </h2>
  <div class="ui divider"></div>
  <p>NO RECORD FROM CAC</p>
</div>
